/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RangeQueryValueLte } from './RangeQueryValueLte';
import {
    RangeQueryValueLteFromJSON,
    RangeQueryValueLteFromJSONTyped,
    RangeQueryValueLteToJSON,
    RangeQueryValueLteToJSONTyped,
} from './RangeQueryValueLte';
import type { RangeQueryValueGte } from './RangeQueryValueGte';
import {
    RangeQueryValueGteFromJSON,
    RangeQueryValueGteFromJSONTyped,
    RangeQueryValueGteToJSON,
    RangeQueryValueGteToJSONTyped,
} from './RangeQueryValueGte';
import type { RangeQueryValueGt } from './RangeQueryValueGt';
import {
    RangeQueryValueGtFromJSON,
    RangeQueryValueGtFromJSONTyped,
    RangeQueryValueGtToJSON,
    RangeQueryValueGtToJSONTyped,
} from './RangeQueryValueGt';
import type { RangeQueryValueLt } from './RangeQueryValueLt';
import {
    RangeQueryValueLtFromJSON,
    RangeQueryValueLtFromJSONTyped,
    RangeQueryValueLtToJSON,
    RangeQueryValueLtToJSONTyped,
} from './RangeQueryValueLt';

/**
 * 
 * @export
 * @interface RangeQueryValue
 */
export interface RangeQueryValue {
    /**
     * 
     * @type {RangeQueryValueGte}
     * @memberof RangeQueryValue
     */
    gte?: RangeQueryValueGte;
    /**
     * 
     * @type {RangeQueryValueLte}
     * @memberof RangeQueryValue
     */
    lte?: RangeQueryValueLte;
    /**
     * 
     * @type {RangeQueryValueGt}
     * @memberof RangeQueryValue
     */
    gt?: RangeQueryValueGt;
    /**
     * 
     * @type {RangeQueryValueLt}
     * @memberof RangeQueryValue
     */
    lt?: RangeQueryValueLt;
}

/**
 * Check if a given object implements the RangeQueryValue interface.
 */
export function instanceOfRangeQueryValue(value: object): value is RangeQueryValue {
    return true;
}

export function RangeQueryValueFromJSON(json: any): RangeQueryValue {
    return RangeQueryValueFromJSONTyped(json, false);
}

export function RangeQueryValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): RangeQueryValue {
    if (json == null) {
        return json;
    }
    return {
        
        'gte': json['gte'] == null ? undefined : RangeQueryValueGteFromJSON(json['gte']),
        'lte': json['lte'] == null ? undefined : RangeQueryValueLteFromJSON(json['lte']),
        'gt': json['gt'] == null ? undefined : RangeQueryValueGtFromJSON(json['gt']),
        'lt': json['lt'] == null ? undefined : RangeQueryValueLtFromJSON(json['lt']),
    };
}

export function RangeQueryValueToJSON(json: any): RangeQueryValue {
    return RangeQueryValueToJSONTyped(json, false);
}

export function RangeQueryValueToJSONTyped(value?: RangeQueryValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gte': RangeQueryValueGteToJSON(value['gte']),
        'lte': RangeQueryValueLteToJSON(value['lte']),
        'gt': RangeQueryValueGtToJSON(value['gt']),
        'lt': RangeQueryValueLtToJSON(value['lt']),
    };
}

